import { createEvent } from 'effector';

import { NotificationState } from './NotificationsState';

export const notificationEvent = createEvent<Partial<NotificationState>>('notificationEvent');
